import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import styles from './LoadingOverlay.styles';
import { withStyles } from '@kaboodle-solutions/design-system';

const LoadingOverlay = ({ classes }) => (
  <div className={classes.container}>
    <img alt="Loading..." src="/images/loading-icon-2024.svg" />
  </div>
);

LoadingOverlay.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
  }).isRequired,
};

export default compose(withStyles(styles))(LoadingOverlay);
